import DashboardCountCard from "components/dashboard/DashboardCountCard";
import { connect } from "react-redux";
import React from "react";
import { withRouter } from "react-router";

const STORE_CARD_VARIANTS = {
  Branches: { icon: "fas fa-code-branch", variant: "teal" },
  Devices: { icon: "fas fa-mobile-alt", variant: "blue" },
  Banners: { icon: "fas fa-image", variant: "violet" },
  Receipts: { icon: "fas fa-receipt", variant: "amber" }
};

const StoreDashboardCountCard = ({
  count,
  title,
  onClick,
  disabled = false
}) => {
  const meta = STORE_CARD_VARIANTS[title] || {
    icon: "fas fa-chart-bar",
    variant: "teal"
  };

  return (
    <DashboardCountCard
      count={count}
      title={title}
      icon={meta.icon}
      variant={meta.variant}
      onClick={onClick}
      disabled={disabled}
    />
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(
  mapStateToProps,
  withRouter,
  null
)(StoreDashboardCountCard);
